import React from 'react';

const SvgLogoCustom = (props) => (
  <svg width="60" height="40" viewBox="25 0 1 40" {...props}>
    <defs>
      <path id="logo_svg__a" d="M0 .752h21.261v33.627H.001z" />
      <path id="logo_svg__c" d="M.148.752H21.41v33.627H.148z" />
      <path id="logo_svg__e" d="M.61.467h6.713v9.227H.61z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(0 .012)">
        <mask id="logo_svg__b" fill="currentColor">
          <use xlinkHref="#logo_svg__a" />
        </mask>
        <path
          d="M18.46 21.297c-1.707-3.856-3.376-7.729-5.05-11.6-.631-1.457-1.27-2.912-1.847-4.391-.723-1.853-.081-3.31 1.75-4.07.491-.203 1.012-.334 1.479-.484H0c.394.09.799.15 1.182.278.384.128.764.292 1.114.494C3.506 2.22 4.27 3.3 4.833 4.547c4.373 9.696 8.748 19.39 13.123 29.085.106.234.216.467.345.747l2.96-7.592-2.802-5.49z"
          fill="currentColor"
          mask="url(#logo_svg__b)"
        />
      </g>
      <g transform="translate(17.747 .012)">
        <mask id="logo_svg__d" fill="currentColor">
          <use xlinkHref="#logo_svg__c" />
        </mask>
        <path
          d="M18.608 21.297c-1.706-3.856-3.376-7.729-5.05-11.6-.63-1.457-1.27-2.912-1.847-4.391-.723-1.853-.08-3.31 1.751-4.07.491-.203 1.012-.334 1.479-.484H.148c.394.09.8.15 1.183.278.384.128.764.292 1.114.494 1.21.695 1.973 1.776 2.536 3.023 4.374 9.696 8.749 19.39 13.124 29.085.106.234.216.467.345.747 1.403-3.6 1.56-4.005 2.96-7.592l-2.802-5.49z"
          fill="currentColor"
          mask="url(#logo_svg__d)"
        />
      </g>
      <path
        d="M48.632 3.378c-.03-.055-.058-.11-.09-.164-.482-.79-1.096-1.449-1.919-1.889-.45-.24-.93-.38-1.447-.354-.373.019-.72.121-1.004.375-.328.293-.452.675-.44 1.104.018.727.387 1.228 1.011 1.562.42.224.874.34 1.332.442.58.13 1.15.297 1.685.559.347.17.666.38.93.665.332.356.516.782.566 1.265.052.512.009 1.019-.164 1.507-.26.731-.787 1.194-1.494 1.467-.62.24-1.266.298-1.925.261a7.919 7.919 0 0 1-1.399-.197c-.605-.145-1.179-.368-1.697-.722-.041-.028-.06-.055-.06-.107l-.011-2.501c0-.015.002-.03.004-.058.077.165.142.318.219.466.524 1.003 1.261 1.803 2.26 2.349a3.65 3.65 0 0 0 1.976.445c.231-.012.457-.055.674-.14.474-.188.76-.527.824-1.04.067-.542-.073-1.015-.463-1.406a3.076 3.076 0 0 0-.834-.573 7.408 7.408 0 0 0-1.504-.53c-.583-.145-1.155-.313-1.68-.617-.518-.3-.92-.704-1.108-1.29-.128-.393-.14-.799-.1-1.208.042-.44.194-.836.469-1.183.311-.394.717-.656 1.181-.833a4.319 4.319 0 0 1 1.564-.267c.754 0 1.485.128 2.188.41.138.054.272.12.406.186.023.012.047.046.047.068.003.648.003 1.295.003 1.948"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default SvgLogoCustom;
